import { useMemo } from "react"
import debounce from "lodash/debounce"

const useDebounce = (fn, delay) => {
  const debouncedFn = useMemo(() => debounce(fn, delay), [fn, delay])

  return debouncedFn
}

export default useDebounce
